<div class="cart-subtotal">
  <span>{{ label }}</span>
  <div class="cart-subtotal__prices">
    <span>{{ formattedTotal }}</span>
    @if (hasDiscount) {
      <span class="cart-subtotal__original">{{ formattedOriginal }}</span>
    }
  </div>
</div>
